import { Button as UiButton, type ButtonProps } from '@ordo/ui/button'
import { cn } from '@ordo/ui/cn'
import { forwardRef } from 'react'

// Kitchen-v2 size variants — applied as className overlays on top of the
// shared @ordo/ui/button so this app preserves its bespoke proportions
// without forking the upstream primitive.
const KITCHEN_SIZE_OVERRIDES: Record<string, string> = {
  default: 'h-9 px-6 py-2 has-[>svg]:px-5',
  xs: "h-6 gap-1 rounded-md px-3 text-xs has-[>svg]:px-2.5 [&_svg:not([class*='size-'])]:size-3",
  sm: 'h-8 gap-1.5 rounded-md px-4 has-[>svg]:px-3.5',
  lg: 'h-10 rounded-md px-8 has-[>svg]:px-6',
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ size = 'default', className, ...rest }, ref) => {
  const override = typeof size === 'string' ? KITCHEN_SIZE_OVERRIDES[size] : undefined
  return <UiButton ref={ref} size={size} className={cn('tracking-normal', override, className)} {...rest} />
})
Button.displayName = 'Button'

export type { ButtonProps } from '@ordo/ui/button'
export { buttonVariants } from '@ordo/ui/button'
